<!-- main.vue -->
<template>
  <div class="toast">
    <p>{{ text }}</p>
  </div>
</template>
  <script>
export default {
  name: "Toast",
  data() {
    return {
      text: "",
      time: 1000
    };
  },
  mounted() {
    setTimeout(() => {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    }, this.time);
  }
};
</script>
  <style scoped>
.toast {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: rgba(255, 255, 255, 0.973);
  z-index: 9999999;
  background: transparent;
}
p {
  padding: 10px 22px;
  font-size: 0.8rem;
  font-weight: 300;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.774);
}
</style>


// WEBPACK FOOTER //
// src/components/toast/main.vue